import { Link, useLocation } from "react-router-dom";

import ProfileMenu from "./ProfileMenu";

import logo from "../assets/png/logoNew.svg";

import { CreativeAssetsIcon, LightOnBulbIcon, PackageSmallIcon } from "../assets/icons";

import { useSection } from "../contexts/section.context";

export default function Header({ projectName }) {

  const { activeSection } = useSection();
  const location = useLocation();

  return (
    <header className="flex-none pe-8 py-4 flex items-center border-b-4 border-b-[#E7EBF1] sticky top-0 z-50 bg-white">
      <div className="flex items-center gap-x-4 flex-1">
        <Link
          to={"/"}
          className=" block ml-10"
        >
          <img
            src={logo}
            alt="Logo of the juice ai"
            className="w-full h-full object-contain"
          />
        </Link>

      </div>

      {(location.pathname === '/') && (
        <div className="flex items-center gap-2">
          <LightOnBulbIcon height={20} width={20} />
          <span className="font-manrope text-sm font-semibold">Concept Testing</span>
        </div>
      )}

      {(location.pathname !== '/home' && location.pathname !== '/' )&& (<div className="flex items-center text-center font-medium gap-2">
        {activeSection.title === 'Concept Testing' && <LightOnBulbIcon height={20} width={20} />}
        {activeSection.title === 'Packaging' && <PackageSmallIcon height={32} width={32} />}
        {activeSection.title === 'Creative Assets' && <CreativeAssetsIcon height={20} width={20} />}
        <span className="font-manrope text-sm font-semibold">
          {activeSection.title}
          {activeSection.title === 'Concept Testing' && projectName && projectName.trim() !== '' && (
            <span> - {projectName}</span>
          )}
        </span>
      </div>)}

      {/* Right Section */}
      <div className="flex-1 flex justify-end">
        <ProfileMenu />
      </div>
    </header>
  );
}
